<template>
  <div class="site-wrap">
    <div class="site-mobile-menu site-navbar-target">
      <div class="site-mobile-menu-header">
        <div class="site-mobile-menu-close">
          <span class="icon-close2 js-menu-toggle"></span>
        </div>
      </div>
      <div class="site-mobile-menu-body"></div>
    </div>
    <NavBar />
    <section id="home-section" class="home-section bg-dark overlay">
      <div class="ban"><div class="container"></div></div>
    </section>
    <b-card header-bg-variant="white">
      <!-- ACTIONS -->
      <b-row>
        <b-col class="mb-3" sm="12" lg="4">
          <b-row>
            <b-col>
              <b-button
                @click="toggleShow(null, 'create')"
                variant="outline-info"
                class="mb-2"
                size="sm"
              >
                <i class="fa fa-plus"></i>
                {{ $t("actions.add") }}
              </b-button>
            </b-col>
          </b-row>
        </b-col>
        <b-col></b-col>
        <b-col sm="6" md="3" class="mb-3">
          <b-row>
            <b-col>
              <b-form-group
                label-cols-sm="4"
                label-cols-md="4"
                label-cols-lg="4"
                label-align-sm="right"
                label-size="sm"
                label-for="perPageSelect"
                class="mb-0 float-right"
                style="width: 130px"
              >
                <b-form-select
                  v-model="limit"
                  id="perPageSelect"
                  size="sm"
                  :options="pageOptions"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <!-- LIST -->
      <b-table
        striped
        small
        bordered
        responsive
        size="sm"
        id="table-transition-example"
        ref="table"
        hover
        :items="list"
        :fields="fields"
        :current-page="page - 1"
        :per-page="limit"
        primary-key="id"
        show-empty
        :busy="loading"
      >
        <template v-slot:empty="{}">
          <p class="text-center m-0 p-2">
            {{ $t("warning.noInformation") }}
          </p>
        </template>
        <template v-slot:cell(index)="data">
          <div>
            {{ data.index + 1 }}
          </div>
        </template>
        <template v-slot:cell(nameUz)="data">
          <div
            style="max-height: 200px; overflow-y: scroll"
            v-html="data.item.nameUz"
          ></div>
        </template>
        <template v-slot:cell(nameLt)="data">
          <div
            style="max-height: 200px; overflow-y: scroll"
            v-html="data.item.nameLt"
          ></div>
        </template>
        <template v-slot:cell(nameKr)="data">
          <div
            style="max-height: 200px; overflow-y: scroll"
            v-html="data.item.nameKr"
          ></div>
        </template>
        <template v-slot:cell(actions)="data">
          <div class="">
            <i
              v-if="false"
              style="font-size: 16px"
              class="fa fa-trash i mr-2"
              @click="confirmDelete(data.item.id)"
            >
            </i>
            <i
              style="font-size: 16px"
              class="fa fa-edit i"
              @click="toggleShow(data.item.id, 'edit')"
            ></i>
            <i
              style="font-size: 16px"
              class="fa ml-2 fa-eye i"
              @click="toggleShow(data.item.id, 'view')"
            ></i>
          </div>
        </template>
      </b-table>

      <!-- PAGINATION -->
      <b-pagination
        class="mt-3"
        size="sm"
        :total-rows="totalCount"
        :per-page="limit"
        v-model="page"
        :prev-text="$t('actions.prev')"
        :next-text="$t('actions.next')"
        hide-goto-end-buttons
      />
      <!-- END -->
    </b-card>
    <b-sidebar
      id="sidebar-right"
      v-model="addShow"
      right
      backdrop
      shadow
      no-header
    >
      <div class="px-8 py-2">
        <b-row>
          <b-col cols="12" class="px-4 mb-4">
            <b-button
              variant="primary"
              @click="addItem"
              v-if="mode !== 'view'"
              class="float-left ml-4"
            >
              {{ $t("actions.save") }}
            </b-button>
            <b-button
              @click="addShow = false"
              variant="light"
              class="float-right mr-4"
            >
              <i class="fa fa-times"></i>
            </b-button>
          </b-col>
          <b-col>
            <div class="px-4 mb-4" style="width: 350px">
              <label> Kod </label>
              <b-form-input :disabled="mode !== 'create'" v-model="form.code">
              </b-form-input>
            </div>
            <b-tabs class="px-4">
              <b-tab title="Lotin">
                <FroalaEditor v-model="form.nameLt" />
              </b-tab>
              <b-tab title="Krill">
                <FroalaEditor v-model="form.nameUz" />
              </b-tab>
              <b-tab :title="$t('lang.kr')">
                <FroalaEditor v-model="form.nameKr" />
              </b-tab>
            </b-tabs>
          </b-col>
        </b-row>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import NavBar from "@/views/NavBar.vue";
import FroalaEditor from "@/components/FroalaEditor";
import Service from "@/services/reference/Title.service";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { mapState, mapActions } from "vuex";
export default {
  mixins: [validationMixin],

  components: {
    NavBar,
    FroalaEditor,
  },
  data() {
    return {
      addShow: false,
      text: "<span></span>",
      totalCount: 0,
      total: 20,
      pageOptions: [20, 50, 100],
      limit: 20,
      page: 1,
      form: {
        nameUz: "",
        nameLt: "",
        nameKr: "",
        code: "",
      },
      loading: false,
      mode: "create",
      currentId: null,
    };
  },
  validations: {
    form: {
      nameLt: {
        required,
      },
      nameUz: {
        required,
      },
      code: {
        required,
      },
    },
  },
  watch: {
    limit() {
      this.getList();
    },
    page() {
      this.getList();
    },
  },
  computed: {
    fields() {
      return [
        {
          key: "index",
          label: this.$t("№"),
          sortable: false,
          class: "text-center",
        },
        {
          key: "code",
          label: "Key",
          sortable: true,
          class: "text-center",
        },
        {
          key: "nameUz",
          label: "Krillcha",
          sortable: true,
          class: "text-center",
        },
        {
          key: "nameLt",
          label: "Lotincha",
          sortable: true,
          class: "text-center",
        },
        {
          key: "nameKr",
          label: "Qaraqalpaq (latın)",
          sortable: true,
          class: "text-center",
        },

        {
          key: "actions",
          label: this.$t("actions.title"),
          class: "text-center",
        },
      ];
    },
    params() {
      return {
        limit: this.limit,
        page: this.page - 1,
      };
    },
    ...mapState("title", { list: "titles" }),
  },
  methods: {
    ...mapActions("title", ["getTitles"]),
    async confirmDelete(id) {
      this.$bvModal
        .msgBoxConfirm(this.$t("actions.delete"), {
          title: this.$t("login.verify"),
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          okTitle: this.$t("actions.yes"),
          cancelTitle: this.$t("actions.no"),
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            await Service.delete(id);
            this.getList();
          }
        });
    },
    async addItem() {
      this.$v.form.$touch();
      if (!this.$v.form.$anyError) {
        if (this.mode == "update") {
          await Service.update({ ...this.form, id: this.currentId });
        } else {
          await Service.create(this.form);
        }
        this.$toast.success(this.$t("succes.saved"));
        this.addShow = false;
        this.getList();
      } else {
        this.$toast.error(this.$t("warning.enter"));
      }
    },
    async getList() {
      this.loading = true;
      try {
        let resData = await this.getTitles(this.params);
        this.total = resData.total;
      } finally {
        this.loading = false;
      }
    },
    async toggleShow(id, mode) {
      this.currentId = id;
      if (mode == "view" || mode == "edit") {
        this.form = (await Service.getById(id)).data;
      } else if (mode == "create") {
        this.form.code = "";
        this.form.nameUz = "";
        this.form.nameLt = "";
      }
      this.addShow = true;
      this.mode = mode;
    },
  },
  created() {
    this.getList();
  },
};
</script>

<style lang="scss">
#sidebar-right {
  &.b-sidebar.b-sidebar-right {
    left: auto;
    right: 0;
    width: 1000px;
    overflow-x: hidden;
  }
  .fr-wrapper {
    height: 65vh !important;
  }
  &.b-sidebar > .b-sidebar-body {
    overflow-x: hidden;
  }
}
.i {
  cursor: pointer;
}
</style>